import { FormFieldTypes } from "../../../data/formFieldType";

export const viewChangeKeyPositionFormData = {
  name: "ViewChangeKeyPosition",
  initialState: {
    companyName: null,
    fromDate: null,
    toDate: null,
    status: null,
  },

  formFields: [
    {
      id: "companyName",
      lable: "Search by Company Name",
      Field_Name: "Search by Company Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "companyName",
      fieldSetting: {
        placeholder: "Enter Company Name",
        allowSpace: true,
      },
      style: {

        containerCss:
          "col-12 col-sm-12 col-md-6 col-lg-4 mb-3 d-flex flex-column justify-content-end",
      },
    },
    {
      id: "fromDate",
      lable: "Request Date",
      Field_Name: "fromDate",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "fromDate",
      fieldSetting: {
        placeholder: "Select",
      },
      style: {
        containerCss:
          "col-12 col-sm-6 col-md-4 col-lg-4 mb-3 d-flex flex-column justify-content-end",
      },
    },
    // {
    //   id: "toDate",
    //   lable: "",
    //   Field_Name: "toDate",
    //   fieldType: FormFieldTypes.DATEPICKER,
    //   dataField: "toDate",
    //   fieldSetting: {
    //     placeholder: "Select",
    //   },
    //   style: {
    //     containerCss:
    //       "col-12 col-sm-6 col-md-4 col-lg-2 mb-3 d-flex flex-column justify-content-end",
    //   },
    //   customLabel: "to",
    // },
    {
      id: "status",
      lable: "Status",
      Field_Name: "Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "status",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss:
          "col-12 col-sm-6 col-md-4 col-lg-4 mb-3 d-flex flex-column justify-content-end",
      },
    },
  ],

  formSetting: {
    isViewOnly: false,
  },
};
